export const displayMedicineText = (medicine) => {
    return `${medicine.name} (${medicine.strength}${medicine.form ? ` ${medicine.form}` : ""})`
}